const doc = [({"en":({"js":({"admin":({"contacts":({"edit":({"organization_content":({"basic_information":"Basic information"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;